import ProjectionProxy from "@/ui/map/ProjectionProxy";
import Location from "@/gis/Location";
import Point from "@/geom/Point";

export default class OSMProjectionProxy extends ProjectionProxy {
    constructor(projectionImpl) {
        super(projectionImpl);
    }

    toWorldZoom(mapZoom) {
		return mapZoom;
	}

    toMapZoom(worldZoom) {
		return worldZoom;
	}

	toWorldOSMTile(mapOSMTile) {
		return mapOSMTile;
	}

	toMapOSMTile(worldOSMTile) {
		return worldOSMTile;
	}

	toWorldLocation(mapLocationOrPoint) {
		if (mapLocationOrPoint instanceof Location) {
			return mapLocationOrPoint;
		} else if (mapLocationOrPoint instanceof Point) {
			return this.projectionImpl.pointToLocation(mapLocationOrPoint);
		} else {
			return null;
		}
	}

	toMapLocation(worldLocation) {
		return worldLocation;
	}

	canIndexByTile() {
		return true;
	}

	/* eslint-disable no-unused-vars */
	getWorldTopLeftCornerForMap(mapTopLeftCorner, worldZoom) {
		return mapTopLeftCorner;
	}
	/* eslint-enable no-unused-vars */
	
	/* eslint-disable no-unused-vars */
	getWorldBottomRightCornerForMap(mapBottomRightCorner, worldZoom) {
		return mapBottomRightCorner;
	}
	/* eslint-enable no-unused-vars */
}
